import { AuthResource, NomenclatureItemResource, NomenclatureTypeResource } from 'speed-js-core';

import AccountProfilesResource from 'coooltv-js-shared/src/api/resources/AccountProfilesResource';
import ChannelResource from 'coooltv-js-shared/src/api/resources/ChannelResource';

import CurrentAccountsResource from 'coooltv-js-shared/src/api/resources/AccountsResource';
import DeviceResource from 'coooltv-js-shared/src/api/resources/DeviceResource';

import ProfileResource from 'coooltv-js-shared/src/api/resources/ProfileResource';

import DeviceSessionResource from 'coooltv-js-shared/src/api/resources/DeviceSessionResource';
import AutoLoginResource from './AutoLoginResource';

export default {
    auth: AuthResource,
    autoLogin: AutoLoginResource,
    accountProfiles: AccountProfilesResource,

    nomenclatureType: NomenclatureTypeResource,
    nomenclatureItem: NomenclatureItemResource,

    channels: ChannelResource,
    currentAccounts: CurrentAccountsResource,

    devices: DeviceResource,
    deviceSession: DeviceSessionResource,

    profiles: ProfileResource,
};
